export default function onlyOnce(fn) {
    return function (...args) {
        if (fn === null) throw new Error("Callback was already called.");
        var callFn = fn;
        fn = null;
        callFn.apply(this, args);
    };
}



// WEBPACK FOOTER //
// ./~/async-es/internal/onlyOnce.js